const common = {
  "site.name": "黑料社区",
  "site.slogan": "穿透表象，还原真相",
  "nav.home": "首页",
  "nav.hotTracking": "热点追踪",
  "nav.deepDive": "深度揭秘",
  "nav.entertainment": "娱乐八卦",
  "nav.society": "社会万象",
  "nav.tech": "科技数码",
  "nav.finance": "财经内幕",
  "nav.about": "关于我们",
  "home.featured": "编辑精选",
  "home.featuredDesc": "每日精选深度好文，不容错过的精彩内容",
  "home.viewAll": "查看全部",
  "home.categories": "浏览分类",
  "home.latest": "最新文章",
  "footer.rights": "版权所有",
  "footer.disclaimer": "内容仅供学习交流，不构成任何建议",
  "footer.privacy": "隐私政策",
  "footer.terms": "用户协议",
  "footer.disclaimerLink": "免责声明",
  "breadcrumb.home": "首页",
  "article.readCount": "阅读",
  "article.readTime": "分钟阅读",
  "article.related": "相关文章",
  "article.share": "觉得文章有用？分享给更多人看到",
  "category.notFound": "分类未找到",
  "category.noArticles": "该分类暂无文章",
  "category.backHome": "返回首页",
  "article.notFound": "文章未找到",
  "about.title": "关于黑料社区",
  "about.brandStory": "品牌故事",
  "about.testimonials": "用户口碑",
  "about.testimonialsDesc": "听听我们的读者怎么说",
  "about.contact": "联系我们",
  "about.contactDesc": "给我们留言",
  "about.email": "电子邮箱",
  "about.phone": "联系电话",
  "about.address": "公司地址",
  "about.workingHours": "工作时间",
  "about.submit": "提交留言",
  "about.submitSuccess": "留言提交成功，我们会尽快回复您！",
  "about.submitError": "提交失败，请稍后再试",
};

export default common;